import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Optional Google Analytics 4 loader.
 * Set REACT_APP_GA_MEASUREMENT_ID in frontend/.env (e.g. G-XXXXXXXXXX).
 * When empty, this component renders nothing and injects nothing.
 */
export default function Analytics() {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const { pathname } = useLocation();

  useEffect(() => {
    if (!gaId) return;
    if (document.getElementById("ga4-script")) return;
    const s = document.createElement("script");
    s.async = true;
    s.id = "ga4-script";
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", gaId, { send_page_view: false });
  }, [gaId]);

  useEffect(() => {
    if (!gaId || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, gaId]);

  return null;
}
